module.exports = __webpack_public_path__ + "img/menu.9ffe3937.svg";